import React, { useEffect, useRef, useState } from 'react';
import styles from '../../utils/styles/components/SmartImage/style.module.css';

export const SmartImage = ({
  alt,
  className,
  decoding = 'async',
  loading,
  onError,
  skeletonClassName,
  src,
  style,
  ...props
}) => {
  const imageRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    setHasError(false);
  }, [src]);

  useEffect(() => {
    const imageNode = imageRef.current;

    if (imageNode?.complete && imageNode.naturalWidth > 0) {
      setIsLoaded(true);
    }
  }, [src]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = (event) => {
    setHasError(true);

    if (onError) {
      onError(event);
    }
  };

  if (hasError) {
    return null;
  }

  return (
    <>
      {!isLoaded ? (
        <span
          aria-hidden="true"
          className={`${styles.skeleton} ${skeletonClassName || className || ''}`}
        />
      ) : null}
      <img
        {...props}
        alt={alt}
        className={`${styles.image} ${className || ''}`}
        decoding={decoding}
        loading={loading}
        onError={handleError}
        onLoad={handleLoad}
        ref={imageRef}
        src={src}
        style={isLoaded ? style : { ...style, opacity: 0 }}
      />
    </>
  );
};
